import React from "react";
import { Card, Statistic, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMobileScreen, faCloudArrowDown, faBoxArchive, faCircleQuestion } from "@fortawesome/free-solid-svg-icons";

/**
 * 4 thẻ số đầu tab "Bản OTA đang chạy".
 *
 * Mỗi thẻ có tooltip giải nghĩa vì 3 trong 4 con số rất dễ hiểu sai — nhất là
 * "Chưa báo bundle" (không phải lỗi, mà là máy chạy bản JS cũ hơn vòng OTA thêm
 * tính năng đo này).
 */

const pct = (part, total) => (total > 0 ? Math.round((part / total) * 100) : 0);

const TILES = [
    {
        key: "users",
        title: "Mở app trong kỳ",
        icon: faMobileScreen,
        color: "#3b82f6",
        hint: "Mẫu số: chỉ tính user thực sự mở app, vì chưa mở thì không thể nhận OTA.",
    },
    {
        key: "ota",
        title: "Đã nhận OTA",
        icon: faCloudArrowDown,
        color: "#10b981",
        hint: "Máy đang chạy bản JS do hot-updater giao, khác bundle gốc trong binary.",
    },
    {
        key: "builtin",
        title: "Còn bản gốc",
        icon: faBoxArchive,
        color: "#f59e0b",
        hint:
            "Đã báo bundle, nhưng vẫn là bản nhúng sẵn trong app tải từ store. Ô này còn đứng ở 0 " +
            "cho tới khi có bản store mới mang sẵn code báo cáo: máy chạy JS gốc hiện không tự khai " +
            "được, nên chúng rơi hết vào 'Chưa báo bundle'.",
    },
    {
        key: "unknown",
        title: "Chưa báo bundle",
        icon: faCircleQuestion,
        color: "#94a3b8",
        hint: "App chạy bản JS cũ hơn vòng OTA 01/10/2026 — chắc chắn CHƯA nhận bản vá.",
    },
];

export default function OtaRolloutStatTiles({ totals }) {
    return (
        // 2 cột trên màn hẹp để 4 thẻ không chiếm hết chiều cao
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
            {TILES.map((it) => {
                const value = totals?.[it.key] || 0;
                return (
                    <Card key={it.key} size="small" styles={{ body: { padding: 16 } }}>
                        <Tooltip title={it.hint}>
                            <div>
                                <Statistic
                                    title={
                                        <span className="flex items-center gap-2 text-content-3">
                                            <FontAwesomeIcon icon={it.icon} style={{ color: it.color }} />
                                            {it.title}
                                        </span>
                                    }
                                    value={value}
                                    valueStyle={{ color: it.color, fontWeight: 600 }}
                                />
                                {it.key !== "users" && (
                                    <div className="text-xs text-content-3 mt-1">
                                        {pct(value, totals?.users)}% số máy
                                    </div>
                                )}
                            </div>
                        </Tooltip>
                    </Card>
                );
            })}
        </div>
    );
}
